import React from "react";
import Courasel from "../Courasel/Courasel";
import { RiDoubleQuotesL } from "react-icons/ri";

import rashid from '../../Assets/Testimonials/rashid.jpeg';
import mulinge from '../../Assets/Testimonials/mulinge.jpg';
import esther from '../../Assets/Testimonials/esther.jpg';
import sheila from '../../Assets/Testimonials/sheila.jpg';

const Testimonials = () => {
  const dummyData = [
    {
      name: "Mulinge Brian",
      position: "CEO, Co-founder",
      company: "EMAKE STUDIOS",
      image: mulinge,
      text: "This is the most important tool for my business. The support team is top notch. I only wish I could give more than 5 stars. Any small business will do very well with this app.",
    },
    {
      name: "Sheila Njoroge",
      position: "Manager",
      company: "ATLANTIC COURIERS",
      image: sheila,
      text: "This is so simple and straightforward. It completely removes the need for me to go into excel. A brilliant little tool that not only helps me generate invoices, but emails them directly and tracks when they are opened too!",
    },
    {
      name: "Esther Kaveni",
      position: "Manager",
      company: "MELINO LAUNDROMAT",
      image: esther,
      text: "This is so simple and straightforward. It completely removes the need for me to go into excel. A brilliant little tool that not only helps me generate invoices, but emails them directly and tracks when they are opened too!",
    },
    {
      name: "Rashid Adalla",
      position: "Co-founder",
      company: "VASSAL TILE LIMITED",
      image: rashid,
      text: "Lovely app. Worth every penny, and the fact that I can take payment straight away via credit/debit card is what I love the most 🙂",
    },
  ];

  return (
    <section className="px-3 xl:px-0 my-32 text-blackColor">
      <div className="relative mx-auto max-w-6xl h-max">
        <div className="space-y-3">
          <h2 className="text-center text-2xl font-semibold md:text-4xl md:leading-[3.4rem]">
            What our customers are saying
          </h2>
          <p className="text-center mx-auto lg:w-1/2">
            We are all about the small details. Our system is designed to help
            you convert more sale opportunities to solid business.
          </p>
        </div>

        <div className="mt-10">
          <Courasel
            arrows="flex"
            direction="X"
            delay={10000}
            flex="row"
            duration="500"
          >
            {dummyData.map((testimonial, i) => (
              <div
                className="relative bg-white rounded-[20px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] space-y-5 p-8 min-w-full mx-auto text-center md:rounded-[40px] md:px-10 md:py-16"
                key={i}
                style={{ transition: "ease-in-out" }}
              >
                <div className="bg-brandColor w-max text-white p-2 rounded-full">
                  <RiDoubleQuotesL className="text-2xl md:text-4xl" />
                </div>
                <p className="text-start md:w-3/4">{testimonial.text}</p>
                <div className="flex flex-row gap-5">
                  <img src={testimonial.image} alt="" className="h-16 w-16 rounded-full object-cover" /> 
                  <div className="text-start">
                    <h2 className="font-semibold md:text-xl">
                      {testimonial.company}
                    </h2>
                    <h3 className="md:text-lg font-semibold">
                      {testimonial.name}
                    </h3>
                    <p>{testimonial.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </Courasel>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
